var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column search-input page-container",style:({
    height: _vm.users.length? 'calc(100% - 205px)' : 'auto'
  })},[_c('TableProject',{attrs:{"headers":_vm.headers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }